// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"817":"c747ec50","1183":"5a8590e1","1390":"f3613019","4801":"a96e68c2","5383":"477f0c96"}[chunkId] + ".chunk.css";
};